import axios from '../utils/axiosInstance';

export const fetchWebhookHistories = async (params) => {
  try {
    const { data } = await axios.get('/api/webhook/history', { params: params });
    return data
  } catch (error) {
    throw error;
  }
};